import { BarChart as RechartsBarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { tokens } from '../../theme/tokens';

interface BarChartProps {
  data: any[];
  xKey: string;
  bars: { key: string; color?: string; name?: string; stackId?: string }[];
  height?: number;
  showGrid?: boolean;
  formatY?: (value: number) => string;
  layout?: 'vertical' | 'horizontal';
  barSize?: number;
}

export function BarChartComponent({
  data,
  xKey,
  bars,
  height = 280,
  showGrid = true,
  formatY,
  layout = 'horizontal',
  barSize,
}: BarChartProps) {
  const isVertical = layout === 'vertical';

  return (
    <ResponsiveContainer width="100%" height={height}>
      <RechartsBarChart
        data={data}
        margin={{ top: 5, right: 20, left: 0, bottom: 5 }}
        layout={isVertical ? 'vertical' : 'horizontal'}
        barGap={2}
      >
        {showGrid && (
          <CartesianGrid strokeDasharray="3 3" stroke={tokens.divider} strokeOpacity={0.5} />
        )}
        {isVertical ? (
          <>
            <XAxis
              type="number"
              tick={{ fontSize: 11, fill: tokens.t3 }}
              tickLine={false}
              axisLine={{ stroke: tokens.divider }}
              tickFormatter={formatY}
            />
            <YAxis
              type="category"
              dataKey={xKey}
              tick={{ fontSize: 11, fill: tokens.t3 }}
              tickLine={false}
              axisLine={false}
              width={80}
            />
          </>
        ) : (
          <>
            <XAxis
              dataKey={xKey}
              tick={{ fontSize: 11, fill: tokens.t3 }}
              tickLine={false}
              axisLine={{ stroke: tokens.divider }}
            />
            <YAxis
              tick={{ fontSize: 11, fill: tokens.t3 }}
              tickLine={false}
              axisLine={false}
              tickFormatter={formatY}
              width={50}
            />
          </>
        )}
        <Tooltip
          contentStyle={{
            background: tokens.surface,
            border: `1px solid ${tokens.cardBorder}`,
            borderRadius: 8,
            boxShadow: tokens.cardShadow,
            fontSize: 12,
            fontFamily: tokens.fontPrimary,
          }}
        />
        {bars.length > 1 && <Legend wrapperStyle={{ fontSize: 11, color: tokens.t2 }} />}
        {bars.map((bar) => (
          <Bar
            key={bar.key}
            dataKey={bar.key}
            fill={bar.color || tokens.accent}
            radius={[3, 3, 0, 0]}
            name={bar.name || bar.key}
            stackId={bar.stackId}
            barSize={barSize}
          />
        ))}
      </RechartsBarChart>
    </ResponsiveContainer>
  );
}
